module.exports = __webpack_public_path__ + "img/title_cover.9a6bbbd.png";